import React from "react";
import Icon from "@etiquette-ui/icons";
import styled from "styled-components";

const IconContainer = styled.div`
  height: 20px;
  width: 20px;
  flex-shrink: 0;
  flex-grow: 0;
  flex-basis: 20px;

  &.half-width {
    height: 16px;
    width: 16px;
  }

  &.third {
    height: 16px;
    width: 16px;
  }

  .bigger {
    height: 28px;
    width: 28px;
    flex-basis: 28px;
  }

  @media screen and (max-height: 750px) {
    height: 17px;
    width: 17px;
    flex-basis: 17px;
    .bigger {
      height: 20px;
      width: 20px;
      flex-basis: 20px;
    }
  }
`;

const ChevronRight: React.FC<{ className?: string; bigger?: boolean }> = ({ className, bigger = false }) => {
  return (
    <IconContainer className={`${bigger ? "bigger" : ""} ${className ?? ''}`}>
      <Icon
        icon={"chevron-right"}
        styles={{
          line: { fill: "none", strokeWidth: "1.5px", stroke: "black" },
          svg: { height: "100%", width: "100%" },
        }}
      />
    </IconContainer>
  );
};

export default ChevronRight;
